// extracted by mini-css-extract-plugin
module.exports = {"PriceList":"pricing-module--PriceList--31Wsu"};